"use client";

import DocsLayout from "@/components/docs/DocsLayout";
import { PageTitle } from "@/components/ui/Title";
import { DocsFooter } from "@/components/docs/DocsFooter";

export default function ManuscriptInsightsPage() {
  return (
    <DocsLayout>
      <div >
        <PageTitle>Manuscript Insights Report</PageTitle>
        <p>
          The manuscript insights report is a high-level summary of your book&apos;s strengths and areas for improvement. It consolidates observations from all our analysis modules—like <b>Plot Coherence</b>, <b>Pacing &amp; Engagement</b>, and <b>Worldbuilding Consistency</b>—into an easy-to-digest overview.
        </p>
        <p>
          Use this report as a roadmap for revisions. Scores for <b>Thematic Depth</b>, <b>Protagonist Development</b>, and <b>Dialogue Effectiveness</b> help you prioritize which sections to revise first. You&#39;ll also see markers for <b>Conflict Stakes</b> and <b>Setting Atmosphere</b>, with links to more detailed analyses for deeper exploration.
        </p>
        <p className="mt-8 border border-dashed rounded-lg p-8 text-center text-muted-foreground">
          Placeholder for sample report screenshots
        </p>
        <DocsFooter />
      </div>
    </DocsLayout>
  );
}
